import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} PortalTierPrice
 * @property {number} id
 * @property {number} portal_id
 * @property {number} agency_id
 * @property {number} threshold_value_cents
 * @property {number} rate_amount_cents
 * @property {number} rate_percentage
 * @property {string} rate_type
 * @property {string} [created_at]
 * @property {string} [updated_at]
 */

/**
 * @typedef {Object} PortalTierPricesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, PortalTierPrice>} data
 */

export const PORTAL_TIER_PRICES_ACTIONS = {
  SET_PORTAL_TIER_PRICES: 'SET_PORTAL_TIER_PRICES',
  SET_PORTAL_TIER_PRICE: 'SET_PORTAL_TIER_PRICE',
  SET_STATUS: 'SET_PORTAL_TIER_PRICES_STATUS',
  SET_ERRORS: 'SET_PORTAL_TIER_PRICES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_PORTAL_TIER_PRICES_ERRORS'
}

export const initialPortalTierPricesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const portalTierPricesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number,
      portal_id: PropTypes.number,
      agency_id: PropTypes.number,
      threshold_value_cents: PropTypes.number,
      rate_amount_cents: PropTypes.number,
      rate_percentage: PropTypes.number,
      rate_type: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string
    })
  )
}
